module.exports = __webpack_public_path__ + "static/media/JohnHicksResume.1828cb89.pdf";